import { makeStyles } from '@mui/styles';

export const useTimleineMessageStyles = makeStyles({
  message: {
    fontSize: '14px',
    fontWeight: 200,
    margin: 0
  },
  badge: {
    marginLeft: '5px'
  }
});
